
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Group } from '@/types/Catalogs'

@Component({
  name: 'AdminGroupSelectionTreeItem'
})
export default class AdminGroupSelectionTreeItem extends Vue {
  @Prop({ required: true })
  group: Group

  @Prop({ required: false, default: false })
  root: boolean

  @Prop({ required: false, default: true })
  opened: boolean

  @Prop({ required: false, default: false })
  watchActive: boolean

  @Prop({ required: false, default: false })
  readOnly: boolean

  open = false

  toggleOpen () {
    this.open = !this.open
  }

  created () {
    this.open = this.opened
  }

  updateSiblings (selected: boolean, group: Group) {
    this.$emit('update-group', selected, group)
  }
}
